import { useState, useEffect } from "react";
import { Routes, Route, Navigate, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, Fuel, Receipt, Clock } from "lucide-react";
import AtendimentoFlow from "@/pages/Atendimento/AtendimentoFlow";
import Caixa from "@/pages/Caixa";
import AppVersionTag from "@/components/AppVersionTag";

export default function FrentistaApp() {
  const { frentista, logoutFrentista } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  const dataCurta = now.toLocaleDateString("pt-BR", { weekday: "short", day: "2-digit", month: "short" });
  const hora = now.toLocaleTimeString("pt-BR");
  const isActive = (p) => loc.pathname.startsWith(p);

  return (
    <div className="min-h-screen flex flex-col" data-testid="frentista-app">
      <header className="max-w-5xl mx-auto w-full px-4 md:px-6 py-3 flex flex-col-reverse md:flex-row md:items-center md:justify-between gap-2.5 md:gap-3">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 md:w-9 md:h-9 rounded-xl glass flex items-center justify-center shrink-0">
            <Fuel size={16} className="text-[color:var(--brand-blue)]" />
          </div>
          <div className="leading-tight">
            <div className="font-semibold text-[16px] md:text-[13px]">{frentista?.nome}</div>
            <div className="text-[12px] md:text-[11px] text-neutral-500 flex items-center gap-1.5">
              <span className="pulse-dot" /> {frentista?.unit_nome}
            </div>
          </div>
        </div>

        {/* Card elegante de data/hora ao centro (mesmo do painel Master) */}
        <div className="hidden md:flex glass rounded-xl px-4 h-11 items-center gap-2.5" data-testid="frentista-clock">
          <Clock size={16} className="text-[color:var(--brand-blue)] shrink-0" />
          <div className="leading-tight">
            <div className="text-[10px] uppercase tracking-wider text-neutral-500 capitalize">{dataCurta}</div>
            <div className="text-[14px] font-semibold text-[color:var(--ink)] number-tabular">{hora}</div>
          </div>
        </div>

        <nav className="flex items-center justify-between md:justify-end gap-2">
          <div className="bg-white border border-[var(--line)] rounded-xl p-1 flex gap-1 shadow-sm">
            <Link to="/frentista/atendimento" data-testid="nav-vendas"
                  className={`px-4 h-10 rounded-lg text-[13px] font-semibold flex items-center gap-1.5 transition-colors ${isActive("/frentista/atendimento") ? "bg-emerald-600 text-white shadow-sm" : "text-emerald-700 hover:bg-emerald-50"}`}>
              <Fuel size={15} /> Vendas
            </Link>
            <Link to="/frentista/caixa" data-testid="nav-caixa"
                  className={`px-4 h-10 rounded-lg text-[13px] font-semibold flex items-center gap-1.5 transition-colors ${isActive("/frentista/caixa") ? "bg-orange-500 text-white shadow-sm" : "text-orange-700 hover:bg-orange-50"}`}>
              <Receipt size={15} /> Caixa
            </Link>
          </div>
          <button
            data-testid="logout-frentista-btn"
            onClick={() => { logoutFrentista(); nav("/"); }}
            className="btn-ghost h-10 w-10 flex items-center justify-center"
            title="Sair"
          >
            <LogOut size={15} />
          </button>
        </nav>
      </header>

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Navigate to="atendimento" replace />} />
          <Route path="atendimento/*" element={<AtendimentoFlow />} />
          <Route path="caixa" element={<Caixa />} />
        </Routes>
      </main>

      {/* Versão no ar (data/hora da última publicação) — clicar abre o histórico de mudanças */}
      <footer className="max-w-5xl mx-auto w-full px-4 md:px-6 py-3 flex justify-center">
        <AppVersionTag />
      </footer>
    </div>
  );
}
